export default __webpack_public_path__ + "static/arindamLehri4-faa351b20ed2b7487817eceb6c959000.jpg";